/**
 * Friendly names for the registration form's keys — one list shared by the error summary and the
 * "Still needed" hint beside the Next button, so both always call a field the same thing.
 * Plain ESM (no JSX) so node:test can import it.
 */
export const FIELD_LABELS = {
  businessVertical: 'Business Vertical',
  companyName: 'Company Name',
  countryOrigin: 'Country of Origin',
  incorporationCertificate: 'Incorporation Certificate',
  contactPersonName: 'SPOC Name',
  designation: 'SPOC Designation',
  directorName: 'Name of the Director',
  directorEmail: 'Director Email',
  altSpocName: 'Alternate SPOC Name',
  altSpocEmail: 'Alternate SPOC Email',
  altSpocDesignation: 'Alternate SPOC Designation',
  altSpocPhone: 'Alternate SPOC Phone Number',
  email: 'SPOC Email',
  emailVerified: 'Email Verification',
  phoneNumber: 'Phone Number',
  website: 'Website',
  yearEstablished: 'Year Established',
  businessDescription: 'Business Description',
  registeredAddress: 'Registered Address',
  registeredCity: 'Registered City',
  registeredState: 'Registered State',
  registeredDistrict: 'Registered District',
  registeredCountry: 'Registered Country',
  registeredPincode: 'Registered Pincode',
  supplyAddress: 'Supply Address',
  supplyCity: 'Supply City',
  supplyState: 'Supply State',
  supplyDistrict: 'Supply District',
  supplyCountry: 'Supply Country',
  supplyPincode: 'Supply Pincode',
  bankName: 'Bank Name',
  branchName: 'Branch Name',
  accountNumber: 'Account Number',
  confirmAccountNumber: 'Confirm Account Number',
  accountType: 'Account Type',
  ifscCode: 'IFSC Code',
  swiftCode: 'Swift Code',
  bankAddress: 'Bank Address',
  bankProof: 'Bank Proof Document',
  annualTurnover: 'Annual Turnover',
  commodityCode: 'Commodity Code',
  msmeStatus: 'MSME Status',
  msmeCategory: 'MSME Category',
  msmeNumber: 'UDYAM Registration Number',
  msmeCertificate: 'MSME Certificate',
  msmeDeclaration: 'MSME Declaration',
  msmeDeclarationFile: 'MSME Declaration',
  classificationYear: 'Classification Year',
  classificationDate: 'Classification Date',
  vendorType: 'Vendor Type',
  industrySector: 'Industry Sector',
  employeeCount: 'Employee Count',
  certifications: 'Certifications',
  preferredCurrency: 'Preferred Currency',
  taxRegistrationNumber: 'Tax Registration Number',
  panNumber: 'PAN Number',
  panDocument: 'PAN Document',
  gstNumber: 'GST Number',
  gstDocument: 'GST Document',
  vatNumber: 'VAT Number',
  cinNumber: 'CIN Number',
  businessLicense: 'Business License Number',
  gstinVerified: 'GSTIN Verification',
  udyamVerified: 'Udyam Lookup',
  bankVerified: 'Bank Verification',
  accountHolderName: 'Account Holder',
  gstTurnoverSlab: 'GST Turnover Slab',
  natureOfAssessee: 'Nature of Assessee',
  tradeName: 'Trade Name',
  legalName: 'Legal Name',
  gtaRegistration: 'GTA Registration',
  specialCertifications: 'Special Certifications',
  dataPrivacyConsent: 'Data Privacy Consent',
  termsConditions: 'Terms & Conditions',
  codeOfConduct: 'Code of Conduct for Business Partners',
  ethicsDeclaration: 'Ethics Declaration',
  complianceAcknowledgment: 'Compliance Acknowledgment',
  digitalSignature: 'Digital Signature',
  agreementDownloads: 'Agreement Downloads',
  finalConfirmation: 'Final Confirmation',
  submit: 'Submission',
  'agreements.nda': 'Mutual Non-Disclosure Agreement',
  'agreements.sqa': 'Supplier Agreement',
  'agreements.fourM': '4M Change Control Agreement',
  'agreements.codeOfConduct': 'Code of Conduct for Business Partners',
  'agreements.complianceAgreement': 'Compliance Agreement',
  'agreements.selfDeclaration': 'Self Declaration',
  'agreements.overseasAgreement': 'Overseas Agreement',
};

/** A key's friendly name. An unmapped camelCase key is spelled out ("panDocument" → "Pan Document"). */
export function fieldLabel(key, labels = FIELD_LABELS) {
  if (labels && labels[key]) return labels[key];
  const last = String(key ?? '').split('.').pop();
  const spaced = last.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
